module.exports = __webpack_public_path__ + "static/media/left-hand.64626a9e.svg";